import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinIconbaseline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16,17 L13,17 L13,7 L11,7 L11,17 L8,17 L12,21 L16,17 Z M4,3 L4,5 L20,5 L20,3 L4,3 Z",
		fill: "currentColor"
	})
});
export default SvgMinIconbaseline;
